import { motion } from 'framer-motion';
import './About.scss';
import ParallaxText from './ParallaxText';
import { age } from './helper';

const About = ({ aboutSection }: { aboutSection: React.RefObject<HTMLElement> }): JSX.Element => {
    const bio = [
        'I continuously work to expand my',
        'knowledge and skillset, by creating',
        'new projects and learning new',
        'frameworks. When I\'m not coding,',
        'you can find me playing the violin,',
        'messing around in Blender, or',
        'staring off into the stars.'
    ];
    const bioExpanded = bio.map(desc => desc.split(''));

    return (
        <section id="about-me" ref={aboutSection}>
            <h4>
                <ParallaxText><>ABOUT ME — ABOUT ME — ABOUT ME — ABOUT ME — </></ParallaxText>
            </h4>
            <div className="constrained-width">
                <motion.h3
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ type: 'tween', duration: 0.6 }}
                >
                    Hi! I'm <span className='gradient-emphasis'>Pranav Pakanati,</span>
                </motion.h3>
                <motion.p
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ type: 'tween', duration: 0.6 }}
                >
                    a {age} year old student with a passion for computer science. I enjoy building
                </motion.p>
                <motion.p
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ type: 'tween', duration: 0.6 }}
                    className='gradient-emphasis'
                >
                    eye catching, yet pixel perfect designs,
                </motion.p>
                <motion.p
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ type: 'tween', duration: 0.6 }}
                >
                    experimenting with 3D graphics,
                </motion.p>
                <motion.p
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ type: 'tween', duration: 0.6 }}
                >
                    and disruptive animations.
                </motion.p>
                <div className="bio-pic-container">
                    <div className="bio">
                        {
                            bioExpanded.map((line, j) => {
                                return (    
                                <p key={j}>
                                    {
                                        line.map((char, i) => {
                                            return <motion.span
                                                initial={{ opacity: 0, y: 30, x: 10 }}
                                                whileInView={{ opacity: 1, y: 0, x: 0 }}
                                                transition={{ type: 'tween', duration: 0.6, delay: 0.3 * (i / line.length) }}
                                                key={i}
                                            >
                                                {char}
                                            </motion.span>
                                        })
                                    }
                                </p>
                                )
                            })
                        }
                    </div>
                    <motion.div className="profile-pic"
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        transition={{ type: 'tween', duration: 1, delay: 0.3, from: 0 }}
                    >
                        <img src='/profile.png' alt='Me!'></img>
                    </motion.div>
                </div>
            </div>
            <h4>
                <ParallaxText reversed><>ABOUT ME — ABOUT ME — ABOUT ME — ABOUT ME — </></ParallaxText>
            </h4>
        </section>
    );
}

export default About;